import axios from "axios";

const state = () => ({
  outlines: null,
  associated_courses: [],
});

const mutations = {
  SET_OUTLINES(state, outlines) {
    state.outlines = outlines;
  },
  SET_ASSOCIATED_COURSES(state, courses) {
    state.associated_courses = courses;
  },
};

const getters = {
  getOutlines: (state) => {
    return state.outlines;
  },
  getAssociatedCourses: (state) => {
    return state.associated_courses;
  },
};

const actions = {
  async fetchCourseOutlines({ commit }, id) {
    const url = process.env.VUE_APP_API_URL + `/utilities/outlines/${id}`;

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      const response = await axios.get(url, config);

      commit("SET_ASSOCIATED_COURSES", response.data[0].associated_courses);
      commit(
        "SET_OUTLINES",
        JSON.parse(response.data[0].selected_course_outline)
      );
    } catch (error) {
      commit("SET_OUTLINES", null);
      commit("SET_ASSOCIATED_COURSES", []);
      throw error?.response?.data;
    }
  },

  async updateOutlines(_, { id, payload }) {
    console.log("Updating outlines with payload:", { id, payload });
    const url = process.env.VUE_APP_API_URL + `/utilities/outlines/${id}`;

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      const response = await axios.patch(url, payload, config);
      return response.data;
    } catch (error) {
      console.log(error);
      throw error?.response?.data;
    }
  },

  async deleteOutlines({ dispatch }, id) {
    const url = process.env.VUE_APP_API_URL + `/utilities/outlines/${id}`;

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      const response = await axios.delete(url, config);

      dispatch(
        "toastNotification/displayToast",
        {
          message: `${response?.data?.message || "Course outline deleted"}`,
          type: "success",
        },
        { root: true }
      );
      return;
    } catch (error) {
      console.log(error);
      dispatch(
        "toastNotification/displayToast",
        {
          message: "Failed to delete course outline",
          type: "warning",
        },
        { root: true }
      );
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
